import { render, staticRenderFns } from "./StockHoldingAnalysisReport.vue?vue&type=template&id=08acb01e&"
import script from "./StockHoldingAnalysisReport.vue?vue&type=script&lang=js&"
export * from "./StockHoldingAnalysisReport.vue?vue&type=script&lang=js&"
import style0 from "./StockHoldingAnalysisReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports